import React, { useEffect, useRef, useState } from "react";
import ProductCategoryHeader from "../../screens/ProductsCategory/productCategoryHeader";
import BannersCategory from "../bannersCategory";
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
} from "react-virtualized";
import FilterProductSpecItem from "../filterProduct/specItem";
import "./style.scss";
import FilterProductItem from "../filterProduct/item";
import { useSelector } from "react-redux";
import { selectViewport } from "../../redux/reducers/slice/common";
import { Spin } from "antd";
import { LoadingPage } from "../images";
import { slugify } from "../../shared/helpers";

const VirtualizeItem = (props: any) => {
  const { virtualizeItems, history } = props;
  const viewport = useSelector(selectViewport);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // trick để đảm bảo rằng component đã sẵn sàng
    setTimeout(() => {
      setIsReady(true);
    }, 1000);

    if (!isReady) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isReady]);

  const cache = React.useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 100,
    })
  );

  const showItem = (index: number) => {
    const item = virtualizeItems[index];

    switch (item.type) {
      case "category":
        if (!item.data) return null;
        return (
          <div key={index}>
            <ProductCategoryHeader history={history} sectionItem={item.data} />
          </div>
        );

      case "banner":
        if (!item.data) return null;
        return (
          <div key={index} style={{ minHeight: "100vh" }}>
            <BannersCategory banners={item.data} />
          </div>
        );

      case "title":
        if (!item.data) return null;
        return (
          <div
            className="product-name-wrap"
            key={index}
            id={`${slugify(item.data)}`}>
            <span className="large-title product-name-title ">{item.data}</span>
          </div>
        );

      case "specs":
        if (!item.data) return null;
        return item.data.map((productItem: any, item_index: number) => {
          return (
            <div
              className="virtualize-item-container"
              key={`virtualize_item_${productItem._id || item_index}`}>
              <FilterProductSpecItem
                {...props}
                product={item.product}
                spec={productItem}
                feature={item.product.data}
                parentIndex={index}
                index={index}
              />
            </div>
          );
        });

      case "features":
        if (!item.data) return null;
        return item.data.map((productItem: any, item_index: number) => {
          return (
            <div
              className="virtualize-item-container"
              key={`virtualize_item_${productItem._id || item_index}`}>
              <FilterProductItem
                {...props}
                slug={props.slug}
                product={item.product}
                feature={productItem}
                parentIndex={index}
                index={index}
              />
            </div>
          );
        });

      default:
        return null;
    }
  };

  const rowRenderer = ({ index, key, parent, style }: any) => (
    <CellMeasurer
      cache={cache.current}
      columnIndex={0}
      key={key}
      parent={parent}
      rowIndex={index}>
      {({ measure, registerChild }: any) => (
        <div ref={registerChild} style={style}>
          <div onLoad={measure}>{showItem(index)}</div>
        </div>
      )}
    </CellMeasurer>
  );

  return (
    <div
      className="virtualize-product-list"
      //fake height to ensure the list is scrollable
      style={{ height: "calc(100vh + 500px)", width: "100%" }}>
      {isReady ? (
        <AutoSizer>
          {({ height, width }) => (
            <List
              width={width}
              height={height}
              rowCount={virtualizeItems.length}
              deferredMeasurementCache={cache.current}
              rowHeight={cache.current.rowHeight}
              rowRenderer={rowRenderer}
              style={{ overflow: viewport["ContactUs"] ? "hidden" : "auto" }}
              scrollingContainerRef={scrollRef}
            />
          )}
        </AutoSizer>
      ) : (
        <Spin
          className="kd-loading"
          indicator={
            <img src={LoadingPage} style={{ height: 80, width: "auto" }} />
          }
          spinning={!isReady}
        />
      )}
    </div>
  );
};

export default VirtualizeItem;
